import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ReactTable from 'react-table';
import { Popup } from 'semantic-ui-react';

class IngredientGrid extends Component {
  columns = [
    {
      Header: 'Ingredient Id',
      accessor: 'CN_Code',
      maxWidth: 100,
      filterable: false,
    },
    {
      Header: 'Description',
      accessor: 'Description',
      filterable: false,
      Cell: props => {
        return (
          <Popup
            trigger={<span>{props.value}</span>}
            content={props.value}
            on="hover"
          />
        );
      },
    },
    {
      Header: 'Manufacturer Name',
      accessor: 'ManufactName',
      filterable: false,
      Cell: props => {
        return (
          <Popup
            trigger={<span>{props.value}</span>}
            content={props.value}
            on="hover"
          />
        );
      },
    },
    {
      Header: 'Contributions',
      accessor: 'Contributions',
      filterable: false,
    },
  ];

  render() {
    return (
      <ReactTable
        className="ingredient-grid -striped -highlight modalGrid"
        data={this.props.data}
        columns={this.columns}
        minRows={5}
        defaultPageSize={5}
        showPageSizeOptions={false}
        // resizable={false}
        getTrProps={(state, rowInfo, column) => {
          return {
            style: {
              color:
                rowInfo && rowInfo.original && !rowInfo.original.IsActive
                  ? 'red'
                  : '',
              fontSize: '.9em',
              lineHeight: '8px',
            },
          };
        }}
      />
    );
  }
}

IngredientGrid.defaultProps = {
  data: [],
};

IngredientGrid.propTypes = {
  data: PropTypes.arrayOf(
    PropTypes.shape({
      IsActive: PropTypes.bool.isRequired,
      CN_Code: PropTypes.string.isRequired,
      Description: PropTypes.string.isRequired,
      ManufactName: PropTypes.string,
      Contributions: PropTypes.string,
    })
  ),
};

export { IngredientGrid };



// WEBPACK FOOTER //
// ./src/common/Components/IngredientGrid/IngredientGrid.js